import * as actionTypes from '../actions/actionTypes';
import { PAYMENT_STATUS } from '../../const/payment/PAYMENT_STATUS';
import { PAYMENT_TYPE } from '../../const/payment/PAYMENT_TYPE';

const initialState = {
    bundles: null,
    loading: false,
    selectedBundleID: null,
    paymentOptions: null,
    status: PAYMENT_STATUS.PENDING,
    clientBundleID: null,
    paymentURL: null
};

const reducer = (state = initialState, {type, ...payload}) => {
    switch(type) {
        case actionTypes.GET_BUNDLES_ALL:
            return {
                ...state,
                loading: true,
                selectedBundleID: null,
            };
        case actionTypes.GET_BUNDLES_ALL_SUCCEEDED:
            const {bundles} = payload;
            return {
                ...state,
                bundles,
                loading: false,
            };
        case actionTypes.GET_BUNDLES_ALL_FAIL:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.GET_BUNDLE_PAYMENT_OPTIONS:
            return {
                ...state,
                paymentOptions: null
            };
        case actionTypes.GET_BUNDLE_PAYMENT_OPTIONS_SUCCEEDED:
            const {paymentOptions} = payload;
            return {
                ...state,
                paymentOptions
            };
        case actionTypes.BUY_BUNDLE:
            return {
                ...state,
                clientBundleID: null,
                paymentURL: null
            };
        case actionTypes.BUY_BUNDLE_SUCCEEDED:
            const {url, id} = payload;
            return {
                ...state,
                clientBundleID: id,
                paymentURL: url,
                status: !!url ? PAYMENT_STATUS.PENDING : PAYMENT_STATUS.OK
            };
        case actionTypes.UPDATE_BUNDLE_PAYMENT_STATUS:
            const {status} = payload;
            if(status === PAYMENT_STATUS.CANCEL && !state.clientBundleID) {
                return state;
            }

            return {
                ...state,
                status,
                clientBundleID: null,
                popUpWindow: null
            };
        case actionTypes.SELECT_BUNDLE:
            const {bundleID: selectedBundleID} = payload;
            return {
                ...state,
                selectedBundleID,
                paymentOptions: null
            };
        case actionTypes.CONFIRM_BUNDLE_PAYMENT_SUCCEEDED:
            const { payload: { paymentType, onlinePayment } } = payload;
            return {
                ...state,
                status: (paymentType === PAYMENT_TYPE.IDEAL || onlinePayment) ? PAYMENT_STATUS.PENDING : PAYMENT_STATUS.OK,
            };
        default:
            return state;
    }
};

export default reducer;
